import { EditOutlined } from "@ant-design/icons";
import { Table, Tooltip } from "antd";
import { contentDefineApi } from "api/content-define.api";
import { AppTable } from "components/antd-ui";
import {
  ActionButton,
  TableLayout,
  TableLayoutFooter,
  getTableShowingRange,
} from "components/table";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import {
  ContentDefine,
  ContentDefineType,
  ContentDefineTypeTrans,
} from "types/content-define";
import { QueryParam } from "types/query";
import { getTitle } from "utils";
import { observer } from "mobx-react";
import { ContentDefineModal } from "./components/ContentDefineModal";
// import { StaffModal } from "./components/StaffModal";

const { Column } = Table;
interface BannerQuery extends QueryParam {
  areaId: null | null;
}

export const ContentDefinePage = observer(({ title = "" }) => {
  const [query, setQuery] = useState<BannerQuery>({
    page: 1,
    limit: 10,
    search: "",
    areaId: null,
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ContentDefine[]>([]);
  const [total, setTotal] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedContentDefine, setSelectedContentDefine] = useState<
    Partial<ContentDefine>
  >({});
  const [modalStatus, setModalStatus] = useState<ModalStatus>("create");

  useEffect(() => {
    document.title = getTitle(title);
  }, []);

  useEffect(() => {
    fetchData();
  }, [query]);

  const fetchData = async () => {
    setLoading(true);
    const res = await contentDefineApi.findAll(query);
    setLoading(false);
    setData(res.data.contentDefines);
    setTotal(res.data.total);
  };

  const { showingFrom, showingTo } = getTableShowingRange(
    query.page,
    query.limit,
    total,
  );

  return (
    <div>
      <TableLayout
        table={
          <AppTable<ContentDefine>
            loading={loading}
            pagination={false}
            rowKey="id"
            dataSource={data}
          >
          <Column
            title="Loại"
            dataIndex="type"
            key="type"
            render={(text, record: ContentDefine) => (
              <span>
                {ContentDefineTypeTrans[record.type]}{" "}
                {record.type == ContentDefineType.Hotline
                  ? `: ${record.body}`
                  : ""}
              </span>
            )}
          />

          <Column
            title="Thao tác"
            key="action"
            width={80}
            align="center"
            render={(text, record: ContentDefine) => (
              <div className="flex justify-center items-center">
                <Tooltip title="Cập nhật">
                  <ActionButton
                    aria-label="Cập nhật"
                    onClick={() => {
                      setSelectedContentDefine(record);
                      setVisibleModal(true);
                      setModalStatus("update");
                    }}
                  >
                    <EditOutlined style={{ color: "#6c84e5" }} />
                  </ActionButton>
                </Tooltip>
              </div>
            )}
          />
          </AppTable>
        }
        footer={
          <TableLayoutFooter
            showingFrom={showingFrom}
            showingTo={showingTo}
            total={total}
            currentPage={query.page}
            pageSize={query.limit}
            onChange={({ limit, page }) => {
              query.page = page;
              query.limit = limit;
              setQuery({ ...query });
            }}
          />
        }
      />

      <ContentDefineModal
        onSubmitOk={fetchData}
        onClose={() => setVisibleModal(false)}
        visible={visibleModal}
        contentDefine={selectedContentDefine}
        status={modalStatus}
      />
    </div>
  );
});
